'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './OrderLine.module.scss'

interface OrderLineProps {
	readonly direction?: 'row' | 'column'
	readonly status: string
	readonly description?: string
	readonly placeholders?: object | null
	readonly alert?: string
	readonly deliveryIndex?: number
	readonly dataTestId: string
}
export function OrderLine({
	direction = 'column',
	status,
	description,
	placeholders,
	alert,
	deliveryIndex,
	dataTestId,
}: OrderLineProps) {
	const { t } = useLabels()

	return (
		<div className={cx(direction === 'row' ? styles.row : styles.column)}>
			{deliveryIndex && (
				<span className={styles.delivery}>
					<ClientLabel placeholderValues={{ 1: deliveryIndex }}>
						{t('myPurchases.multi.delivery.text')}
					</ClientLabel>
				</span>
			)}
			<span className={text.uppercaseM} data-testid={`${dataTestId}.status`}>
				{t(status)}
			</span>
			{alert && (
				<span className={styles.alert} data-testid={`${dataTestId}.alert`}>
					<ClientLabel
						{...(placeholders && {
							placeholderValues: { ...placeholders },
						})}
					>
						{t(alert)}
					</ClientLabel>
				</span>
			)}
			{description && !alert && (
				<span
					className={styles.description}
					data-testid={`${dataTestId}.description`}
				>
					<ClientLabel
						{...(placeholders && {
							placeholderValues: { ...placeholders },
						})}
					>
						{t(description)}
					</ClientLabel>
				</span>
			)}
		</div>
	)
}
